export enum PaymentBillingType {
  Recurring = 1,
  Pledge = 0
}
